import styled from 'styled-components'

import { mediaMax } from '../../../constants/breakpoints'

export const Title = styled.h1`
  font-weight: 300;
  color: ${({ theme }) => theme.colors.white};
  /* z-index: 1; */
  font-size: max(24px, 2.91vw);
  width: 70%;
  font-family: ${({ theme }) => theme.fonts.fontFamilyPrimary};
  line-height: 1.2;

  @media ${mediaMax.mobileL} {
    text-align: center;
    width: 100%;
  }
`

export const Abstract = styled.div`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
  width: 70%;

  > * {
    color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
    font-size: max(17px, 1.2vw);
    line-height: 170%;
  }

  @media ${mediaMax.tablet} {
    width: 100%;
  }
`

export const Description = styled.div`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
  width: 70%;
  font-size: max(17px, 1.2vw);
  line-height: 148%;

  @media ${mediaMax.tabletL} {
    width: 100%;
  }
`
export const AboutSpeaker = styled.div`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
  width: 100%;
  > * {
    color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
    font-size: max(14px, 0.97222vw);
    line-height: 148%;
  }

  @media ${mediaMax.tablet} {
    width: 100%;
  }
`
